import { TextField, TextFieldProps } from '@mui/material';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { IncFieldBase } from '../../fields.types';
import { Ref, forwardRef } from 'react';

export type IncTextFieldBaseProps = IncFieldBase<TextFieldProps>;

const IncTextInputBase = forwardRef(
  (
    { IncFormHelperTextProps = {}, helperText, ...rest }: IncTextFieldBaseProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    const { error, ...helperTextPropsRest } = IncFormHelperTextProps;

    return (
      <TextField
        error={!!error}
        helperText={
          <IncFormHelperText
            error={error}
            helperText={helperText}
            {...helperTextPropsRest}
          />
        }
        inputRef={ref}
        {...rest}
      />
    );
  },
);

export default IncTextInputBase;
